// extracted by mini-css-extract-plugin
export default {"countdown":"Laa-z","srOnly":"Maa-z"};